import React from 'react';
import './sec2-gallery.css'
import { useEffect } from 'react';
import { supabase } from '../supabase';
import { useState } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);


const Sec2gallery = () => {

    const [headers, setheaders]= useState([]);

useEffect(() => {
const getheaders = async()=>{
    const res = await supabase.from('static_content').select('*').order('id', { ascending: true });;
setheaders(res.data);
}
getheaders();
}, []);




    const [Imgs, setImgs]= useState([]);

useEffect(() => {
const getimgs = async()=>{
    const res = await supabase.from('gallery_pic').select('*').order('id', { ascending: true });;
setImgs(res.data);
}
getimgs();
}, []);



useEffect(() => {
  const rows = document.querySelectorAll(
    ".containerrr-imgs-row-gallery, .containerrr2-imgs-row-gallery"
  );

  const images = document.querySelectorAll("img");

  let loaded = 0;

  images.forEach((img) => {
    if (img.complete) {
      loaded++;
    } else {
      img.onload = () => {
        loaded++;
        if (loaded === images.length) initAnimation();
      };
    }
  });

  if (loaded === images.length) initAnimation();
function initAnimation() {ScrollTrigger.getAll().forEach(trigger => {
  if (trigger.trigger && trigger.trigger.closest(".sec2-gallery")) {
    trigger.kill();
  }
});

  rows.forEach((row, i) => {
    const distance = row.scrollWidth / 2;

    gsap.to(row, {
      x: i % 2 === 0 ? -distance : distance,
      ease: "none",
      scrollTrigger: {
        trigger: row,
        start: "top bottom",
        end: "bottom top",
        scrub: 1,
        invalidateOnRefresh: true, 
      },
    });
  });

  gsap.delayedCall(0.2, () => ScrollTrigger.refresh());
}
}, [Imgs]);





    return ( 
        <section className='sec2-gallery'>
            <section className=' container-cards-sec2-gallery '>
                <article className='container-title-sec2-gallery-contt'>
                     <article className='container-title-sec2-gallery'>
                            <h1 className='header-sec3-p3'>{headers?.[21]?.header}</h1>
                    
                    </article>
          
                    
                </article>
               <section className="container2-cards-sec2-gallery">
                    
                       <figure className='containerrr-imgs-row-gallery'>
                         {Imgs.map((img) => (
                        <img src={img.image} alt={img.img_alt}  />
                                ))}
                      </figure>


                       <figure className='containerrr2-imgs-row-gallery'>
                          {Imgs.map((img) => (
                        <img src={img.image} alt={img.img_alt}  />
                                ))}
                      </figure>
                    
                       <figure className='containerrr-imgs-row-gallery'>
                       {Imgs.map((img) => (
                        <img src={img.image} alt={img.img_alt}  />
                                ))}
                      </figure>            


            
                    </section>
            </section>
        </section>
     );
}
 
export default Sec2gallery;